import { Brick, registerBrick, Auth } from 'olympe';

export default class SSOLogin extends Brick {

    /**
     * Executed every time the brick receives a new trigger event.
     * Note that the method will be executed _even if_ an input () is undefined.
     * 
     * @protected
     * @param {BrickContext} context
     * @param {!Array} inputs
     * @param {function()} forwardEvent
     */
    onUpdate(context, inputs, [forwardEvent]) {
       Auth.loginSAML('ssoNestle','uuN%jMvNdttJdg*Z').then(
           result => {
               console.log(`Auth Status : ${Auth.getState()}`)
           }
       )

    }
}

registerBrick('017a3e1bfe0318ff64e0', SSOLogin);
